<template>
  <v-container fluid class="homedepot">
    <v-row no-gutters class="homedepot-main">
      <v-col cols="12" md="12" class="left-pane">

        <!--v-card class="search-card" flat>
          <v-row class="ma-0" align="center">
            <v-col cols="12" md="9" class="py-2"-->
            <v-row class="ma-0">
              <v-col cols="4" class="pa-0 ma-0">
                <v-text-field
                  v-model="searchQuantity"
                  hide-details
                  filled
                  rounded
                  dense
                  inputmode="decimal"
                  pattern="^\\d*\\.?\\d*$"
                  class="mx-2 mb-4"
                  @input="searchQuantity = sanitizeQuantity($event)"
                  @keydown="blockQuantityKey"
                  @paste="handleQuantityPaste"
                  @blur="normalizeSearchQuantity"
                ></v-text-field>
              </v-col>
              <v-col cols="8" class="pa-0 ma-0">
                <v-text-field
                  ref="searchField"
                  v-model="searchInput"
                  :loading="searching"
                  hide-details
                  placeholder="Buscar..."
                  prepend-inner-icon="mdi-magnify"
                  append-icon="mdi-barcode"
                  filled
                  rounded
                  dense
                  @keydown.enter="runSearch"
                  class="mx-2 mb-4"
                  @click:append="scanner = true"
                ></v-text-field>
              </v-col>
            </v-row>
            <!--/v-col>
            <v-col cols="12" md="3" class="py-2">
              <v-btn
                block
                color="primary"
                class="elevation-0"
                :loading="searching"
                @click="runSearch"
              >
                Buscar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-->

        <v-card :class="'cart-card'" flat>
          <div class="cart-header">
            Articulos en carrito
            <span class="cart-count">({{ cartCount }})</span>
          </div>
          <v-divider></v-divider>
          <v-list class="cart-list" v-if="StoreCart.length">
            <v-list-item
              v-for="(item, index) in StoreCart"
              :key="item.product.id"
              class="cart-item"
            >
            <div>
              <div class="item-qty">{{ item.quantity }}x</div>
              <div class="item-actions">
                <v-btn icon small @click="downItem(index)">
                  <v-icon small>mdi-minus</v-icon>
                </v-btn>
                <v-btn icon small @click="upItem(item.product.id, index)">
                  <v-icon small>mdi-plus</v-icon>
                </v-btn>
              </div>
            </div>
              <div class="item-details">
                <div style="    display: inline-flex;">
                  <div class="item-name mt-1 mr-2">{{ item.product.name }}</div>
                  <v-btn icon small color="error" @click="removeItem(index)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </div>
                <div class="item-meta">SKU: {{ item.product.code_one || '-' }}</div>
                <div class="item-meta">Inventario: {{ item.product.inventory }}</div>
                
              </div>
              <div>
                <div class="item-total">{{ formatMoney(lineTotal(item)) }}</div>
                <div class="item-price">
                  <span>
                    {{ formatMoney(priceWithIva(item.product.price)) }} c/u
                  </span>
                  <div v-if="requiresCashierPriceAdjustment(item.product)" class="price-warning">
                    Se va a tener que ajustar el precio en caja.
                  </div>
                  <v-text-field
                    v-if="!item.product.sat_key_code"
                    class="sat-edit"
                    hide-details
                    dense
                    label="Codigo SAT"
                    v-model="item.product.new_sat_key_code"
                  ></v-text-field>
                </div>
              </div>
            </v-list-item>
          </v-list>
          <div v-else class="empty-cart">
            Aun no hay articulos en el carrito.
          </div>
        </v-card>
      </v-col>

      
    </v-row>

    <v-row class="bottom-bar pa-0 ma-0">
        <v-row class="ma-0 pt-2">
            <v-col cols="4">
                <v-row class="ma-0">
                    <v-spacer/>
                    <div class="total-block pb-2">
                        <div class="label">Subtotal</div>
                        <div class="value">{{ formatMoney(subtotal) }}</div>
                    </div>
                    <v-spacer/>
                </v-row>
            </v-col>
            <v-col cols="4">
                <v-row class="ma-0">
                    <v-spacer/>
                    <div class="total-block pb-2">
                        <div class="label">IVA</div>
                        <div class="value">{{ formatMoney(iva) }}</div>
                    </div>
                    <v-spacer/>
                </v-row>
            </v-col>
            <v-col cols="4">
                <v-row class="ma-0">
                    <v-spacer/>
                    <div class="total-block pb-2">
                        <div class="label">Total</div>
                        <div class="value">{{ formatMoney(subtotal + iva) }}</div>
                    </div>
                    <v-spacer/>
                </v-row>
            </v-col>
        </v-row>
        <v-btn
            block
            class="action-btn action-btn--continue elevation-0 p-0"
            color="#e25104"
            dark
            :loading="loader"
            :disabled="isSaveDisabled"
            @click="saveSale(true)"
        >
            Continuar
        </v-btn>
    </v-row>

    <v-dialog v-model="resultsDialog" max-width="900px">
      <v-card>
        <v-card-title>Resultados de busqueda</v-card-title>
        <v-divider></v-divider>
        <v-list>
          <v-list-item
            v-for="result in searchResults"
            :key="result.id"
            class="result-item"
          >
            <v-list-item-content>
              <v-list-item-title>{{ result.name }}</v-list-item-title>
              <v-list-item-subtitle>
                SKU: {{ result.code_one || '-' }} | Inventario: {{ result.inventory }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <div class="result-price-wrap">
              <div class="result-price">{{ formatMoney(result.price*1.16) }}</div>
              <div v-if="requiresCashierPriceAdjustment(result)" class="price-warning">
                Se va a tener que ajustar el precio en caja.
              </div>
            </div>
            <v-btn small color="primary" @click="selectResult(result)">Agregar</v-btn>
          </v-list-item>
        </v-list>
        <v-divider v-if="searchMeta.last_page > 1"></v-divider>
        <v-card-actions v-if="searchMeta.last_page > 1">
          <v-spacer/>
          <v-pagination
            v-model="searchPage"
            :length="searchMeta.last_page"
            total-visible="7"
            @input="fetchSearchPage"
          ></v-pagination>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogTicket" max-width="350px">
      <bdbTicket
        v-if="backend_link === 'https://backendbdb.unocrm.mx/'"
        @cerrar="cerrarTicket"
        v-bind:ticket="ticket"
        :display-total="subtotal + iva"
      />
      <ticket
        v-else
        @cerrar="cerrarTicket"
        v-bind:ticket="ticket"
        :display-total="subtotal + iva"
      />
    </v-dialog>

    <v-snackbar :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.message }}
    </v-snackbar>

    <!-- Dialogo scanner -->
    <v-dialog v-model="scanner" max-width="350px">
        <v-quagga v-if="scanner" 
        :onDetected="logIt" 
        :readerTypes="['ean_reader']"
        :readerSize="readerSize"
        :aspectRatio="aspectRatio"
        ></v-quagga>
    </v-dialog> 


  </v-container>
</template>

<script>
import axios from "axios";
import Ticket from "../pos/Ticket";
import BdbTicket from "../pos/BdbTicket";

export default {
  components: {
    ticket: Ticket,
    bdbTicket: BdbTicket,
  },
  data: () => ({
    searchInput: "",
    searchQuantity: "1",
    searching: false,
    searchResults: [],
    resultsDialog: false,
    searchTerm: "",
    searchPage: 1,
    searchMeta: {
      current_page: 1,
      last_page: 1,
      total: 0,
      per_page: 20,
    },
    loader: false,
    dialogTicket: false,
    savedSale: null,
    scanner: false,
    readerSize: { width: 640, height: 480 },
    aspectRatio: { min: 1, max: 2 },
    snackbar: {
      show: false,
      message: null,
      color: null,
    },
    ticket: {
      company_id: null,
      user_id: "",
      note: "",
      items: [
        {
          quantity: 1,
          item: "",
          price: "",
        },
      ],
      status: "venta_pendiente",
      bar: 1,
      subtotal: "",
      date: "",
      iva: "",
      total: "",
      invoice: "",
      created_by_user_id: "",
      last_updated_by_user_id: "",
      payment_form: "01",
      payment_method: "PUE",
    },
  }),
  computed: {
    backend_link() {
      return process.env.VUE_APP_BACKEND_ROUTE;
    },
    StoreCart() {
      return this.$store.state.cart.carts;
    },
    cartCount() {
      return this.StoreCart.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    },
    client() {
      return this.$store.state.cart.client;
    },
    currentUser() {
      return this.$store.state.currentUser.user;
    },
    subtotal() {
      const total = (this.StoreCart || []).reduce((sum, item) => {
        const unit = this.priceWithoutDiscount(item.product.price);
        return sum + this.lineSubtotal(item, unit);
      }, 0);
      return Math.max(total, 0);
    },
    iva() {
      const rate = 0.16;
      return Math.max(this.round2(this.subtotal * rate), 0);
    },
    isSaveDisabled() {
      if (!this.StoreCart.length) {
        return true;
      }
      if (!this.client || !this.client.id) {
        return true;
      }
      return this.loader;
    },
  },
  created() {
    this.$store.dispatch("currentUser/getUser");
    this.ensureClient();
  },
  watch: {},
  methods: {
    logIt (data) {
      const code = data?.codeResult?.code;
      if (!code || this.searching) {
        return;
      }
      this.searchInput = code;
      this.scanner = false;
      this.$nextTick(() => {
        this.runSearch();
      });
    },
    sanitizeQuantity(value) {
      const raw = String(value ?? "");
      let cleaned = raw.replace(/[^0-9.]/g, "");
      const firstDot = cleaned.indexOf(".");
      if (firstDot !== -1) {
        cleaned = cleaned.slice(0, firstDot + 1) + cleaned.slice(firstDot + 1).replace(/\./g, "");
      }
      return cleaned;
    },
    normalizeQuantity(value) {
      const parsed = parseFloat(value);
      if (!Number.isFinite(parsed) || parsed <= 0) {
        return 1;
      }
      return parsed;
    },
    normalizeSearchQuantity() {
      this.searchQuantity = String(this.normalizeQuantity(this.searchQuantity));
    },
    blockQuantityKey(event) {
      const { key, ctrlKey, metaKey, altKey } = event;
      if (ctrlKey || metaKey || altKey) return;

      const controlKeys = [
        "Backspace",
        "Delete",
        "Tab",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End",
      ];
      if (controlKeys.includes(key)) return;

      if (key === ".") {
        if (String(this.searchQuantity || "").includes(".")) {
          event.preventDefault();
        }
        return;
      }

      if (!/^\d$/.test(key)) {
        event.preventDefault();
      }
    },
    handleQuantityPaste(event) {
      const text = event.clipboardData?.getData("text") ?? "";
      const sanitized = this.sanitizeQuantity(text);
      event.preventDefault();

      const target = event.target;
      const current = String(this.searchQuantity ?? "");
      const start = target?.selectionStart ?? current.length;
      const end = target?.selectionEnd ?? current.length;
      const nextValue = current.slice(0, start) + sanitized + current.slice(end);
      this.searchQuantity = this.sanitizeQuantity(nextValue);
    },
    getSearchQuantity() {
      return this.normalizeQuantity(this.searchQuantity);
    },
    ensureClient() {
      if (!this.client || !this.client.id) {
        this.$store.dispatch("cart/selectClient", {
          id: "19",
          name: "Mostrador",
          price_list: { name: "Precio 4" },
        });
      }
    },
    round2(value) {
      return Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;
    },
    lineSubtotal(item, unitPrice) {
      const qty = Number(item.quantity || 0);
      return this.round2(Number(unitPrice || 0) * qty);
    },
    requiresCashierPriceAdjustment(product) {
      return Number(product?.price || 0) <= 0;
    },
    priceWithIva(value) {
      return Number(value || 0) * 1.16;
    },
    lineTotal(item) {
      return this.lineSubtotal(item, this.priceWithIva(item.product.price));
    },
    formatMoney(value) {
      return Number(value || 0).toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
      });
    },
    rellenar(sat_key) {
      if (sat_key === "1010101" || sat_key === 1010101) {
        return "31162800";
      }
      return sat_key;
    },
    priceList(price) {
      switch (price) {
        case "Precio 1":
          return "price";
        case "Precio 2":
          return "price_two";
        case "Precio 3":
          return "price_three";
        case "Precio 4":
          return "price_four";
        default:
          return "price_four";
      }
    },
    productPrice(product) {
      if (this.backend_link === "https://backendbdb.unocrm.mx/") {
        return product.price;
      }
      if (this.client && this.client.price_list && this.client.price_list.name) {
        const priceKey = this.priceList(this.client.price_list.name);
        return product[priceKey] * 1;
      }
      return product.price_four;
    },
    normalizeProduct(product) {
      return {
        id: product.id,
        name: product.name,
        price: this.round2(this.productPrice(product)),
        cost: product.current_cost,
        code_one: product.code_one,
        facturapi_id: product.facturapi_id,
        sat_key_code: this.rellenar(product.sat_key_code),
        new_sat_key_code: "",
        edit: false,
        unit: product.unit,
        inventory: product.current_inventory,
        branch_inventories: product.branch_inventories,
      };
    },
    runSearch() {
      if (!this.searchInput) {
        return;
      }
      this.normalizeSearchQuantity();
      this.searchTerm = this.searchInput;
      this.searchPage = 1;
      this.fetchSearchResults(1, { resetInput: true });
    },
    fetchSearchPage(page) {
      this.fetchSearchResults(page);
    },
    fetchSearchResults(page = 1, { resetInput = false } = {}) {
      if (!this.searchTerm) {
        return;
      }
      this.searching = true;
      axios
        .get(
          process.env.VUE_APP_BACKEND_ROUTE +
            "api/v2/item/pos?filter[is_published]=1&filter[pos]=" +
            encodeURIComponent(this.searchTerm) +
            "&itemsPerPage=20&page=" +
            page
        )
        .then((response) => {
          const items = (response.data.data || []).map((item) => this.normalizeProduct(item));
          const meta = response.data.meta || response.data || {};
          const total = Number(meta.total ?? items.length);
          const lastPage = Number(meta.last_page ?? 1);
          const currentPage = Number(meta.current_page ?? page);

          this.searchMeta = {
            current_page: currentPage,
            last_page: lastPage,
            total,
            per_page: Number(meta.per_page ?? 20),
          };
          this.searchPage = currentPage;

          if (total === 1 && items.length === 1) {
            this.addToCart(items[0], this.getSearchQuantity());
            this.resultsDialog = false;
            this.searchResults = [];
            return;
          }
          if (items.length > 0) {
            this.searchResults = items;
            this.resultsDialog = true;
          } else {
            this.resultsDialog = false;
            this.searchResults = [];
            this.snackbar = {
              show: true,
              message: "No se encontraron productos.",
              color: "warning",
            };
          }
        })
        .catch(() => {
          this.snackbar = {
            show: true,
            message: "No se pudo buscar productos.",
            color: "error",
          };
        })
        .finally(() => {
          this.searching = false;
          if (resetInput) {
            this.searchInput = "";
            this.$nextTick(() => {
              if (this.$refs.searchField) {
                this.$refs.searchField.focus();
              }
            });
          }
        });
    },
    selectResult(item) {
      this.addToCart(item, this.getSearchQuantity());
      this.resultsDialog = false;
      this.searchResults = [];
    },
    addToCart(product, quantity = 1) {
      const qty = this.normalizeQuantity(quantity);
      this.$store.dispatch("cart/addItemWithQuantity", { item: product, quantity: qty });
      this.searchQuantity = 1
    },
    removeItem(index) {
      this.$store.dispatch("cart/removeItem", index);
    },
    downItem(index) {
      this.$store.dispatch("cart/downItem", index);
    },
    upItem(id, index) {
      this.$store.dispatch("cart/upItem", { id, index });
    },
    priceWithoutDiscount(price) {
      return price;
    },
    saveSale() {
      this.ensureClient();
      this.loader = true;
      const serie = "Serie B";

      this.ticket = {
        company_id: this.client.id,
        user_id: this.currentUser.id,
        note: "",
        items: this.StoreCart.map((item) => ({
          quantity: item.quantity * 1,
          item: item.product.id,
          price: this.priceWithoutDiscount(item.product.price, item.quantity * 1),
          cost: item.product.cost,
          value: item.product.price,
        })),
        status: "venta_pendiente",
        bar: 1,
        subtotal: this.subtotal,
        iva: this.iva,
        total: this.subtotal + this.iva,
        date: new Date()
          .toLocaleString("sv-SE", { timeZone: "America/Monterrey" })
          .toString()
          .slice(0, 10),
        created_by_user_id: this.currentUser.id,
        last_updated_by_user_id: this.currentUser.id,
        id: "",
        self_invoice_url: "",
        type: serie,
        receipt: {
          items: this.StoreCart.map((item) => ({
            quantity: item.quantity * 1,
            product: this.facturapi_product_id(item.product),
          })),
        },
        payment_form: this.ticket.payment_form || "01",
        payment_method: this.ticket.payment_method || "PUE",
      };

      axios
        .post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/sales", this.ticket)
        .then((response) => {
          const resp = response.data.data;
          this.savedSale = resp;
          this.ticket = {
            id: resp.id,
            company_id: resp.company.id,
            note: resp.note,
            bar: resp.bar,
            subtotal: resp.subtotal,
            iva: resp.iva,
            total: resp.total,
            date: resp.date,
            created_at: resp.created_at,
            user_id: this.currentUser.id,
            user: this.currentUser,
            items: resp.items.map((i) => ({
              quantity: i.quantity,
              product: i.item,
              price: i.price,
            })),
            status: resp.status,
            self_invoice_url: resp.self_invoice_url,
            payment_form: this.ticket.payment_form,
            payment_method: this.ticket.payment_method,
          };
         location.reload();
        })
        .catch((error) => {
          this.snackbar = {
            message: error.response?.data?.message || "Error al guardar la venta.",
            color: "error",
            show: true,
          };
        })
        .finally(() => {
          this.loader = false;
        });
    },
    cerrarTicket() {
      this.dialogTicket = false;
      location.reload();
    },
    facturapi_product_id(product) {
      if (!product.sat_key_code) {
        product.sat_key_code = product.new_sat_key_code;
      }
      return {
        description: product.name,
        product_key: product.sat_key_code,
        price: product.price,
        tax_included:
          process.env.VUE_APP_BACKEND_ROUTE === "https://backendmf.unocrm.mx/" ? undefined : false,
        taxability:
          process.env.VUE_APP_BACKEND_ROUTE === "https://backendmf.unocrm.mx/" ? "02" : "02",
        taxes:
          process.env.VUE_APP_BACKEND_ROUTE === "https://backendmf.unocrm.mx/"
            ? [
                {
                  type: "IVA",
                  rate: 0,
                },
              ]
            : [
                {
                  type: "IVA",
                  rate: 0.16,
                },
              ],
        sku: product.code_one,
        unit_key: "H87",
        unit_name: "Pieza",
      };
    },
  },
};
</script>

<style scoped>
.action-col[data-v-96c043e0], .action-row[data-v-96c043e0], .action-cell[data-v-96c043e0], .v-btn:not(.v-btn--round).v-size--default[data-v-96c043e0] {
    height: 50px !important;
}
.homedepot {
  --accent: #f37021;
  --dark: #3e3e3e;
  --panel: #f7f7f7;
  background: #f2f2f2;
  min-height: calc(100vh - 64px);
  max-height: calc(100vh - 64px);
}

.homedepot-main {
  min-height: calc(100vh - 145px);
  max-height: calc(100vh - 145px);
}

.left-pane {
  padding: 16px;
}

.search-card {
  background: #ffffff;
  padding: 8px 12px;
  margin-bottom: 12px;
}

.ticket-strip {
  background: #ffffff;
  border: 1px solid #e6e0d3;
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 12px;
}

.ticket-strip-title {
  font-weight: 700;
  color: #6b5a2a;
  margin-bottom: 8px;
}

.ticket-strip-list {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 4px;
}

.ticket-card {
  padding: 10px 12px;
  border-radius: 10px;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  min-width: 180px;
  flex: 0 0 auto;
}

.ticket-card--selected {
  border: 2px solid #e25104 !important;
  box-shadow: 0 0 0 2px rgba(226, 81, 4, 0.15);
}

.ticket-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}

.ticket-card-id {
  font-weight: 700;
  color: #e25104;
  margin-bottom: 4px;
}

.ticket-card-name {
  font-weight: 600;
  font-size: 14px;
  color: #3f3f3f;
}

.ticket-card-meta {
  font-size: 12px;
  color: #7a7a7a;
}

.cart-card {
  background: #ffffff;
  padding: 0;
  min-height: calc(100vh - 250px);
  max-height: calc(100vh - 250px);
  overflow: auto;
}

.mini-cart-card {
  background: #ffffff;
  padding: 0;
  min-height: calc(100vh - 380px);
  max-height: calc(100vh - 380px);
  overflow: auto;
}

.cart-header {
  font-weight: 700;
  font-size: 18px;
  padding: 16px 16px 8px 16px;
  color: var(--dark);
}

.cart-count {
  color: var(--accent);
}

.cart-list {
  max-height: calc(100vh - 260px);
  overflow-y: auto;
}

.cart-item {
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #e0e0e0;
}

.item-qty {
  font-size: 20px;
  font-weight: 700;
  color: var(--accent);
  width: 70px;
  text-align: center;
}

.item-details {
  flex: 1;
}

.item-name {
  font-weight: 600;
}

.item-meta {
  font-size: 12px;
  color: #777;
}

.item-price {
  font-size: 13px;
  color: #4f4f4f;
}

.price-warning {
  color: #d56a00;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  max-width: 180px;
}

.item-total {
  font-weight: 700;
  color: #3f3f3f;
  margin-right: 8px;
}

.item-actions {
  display: flex;
  gap: 4px;
}

.price-edit,
.sat-edit {
  max-width: 200px;
}

.empty-cart {
  padding: 24px;
  color: #888;
  text-align: center;
}

.bottom-bar {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  background: #3b3b3b;
  color: white;
  padding: 12px 24px;
  position:fixed;
  bottom:0;
  width:100vw;
  left:0;
}

.totals {
  display: flex;
  gap: 32px;
}

.total-block .label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #d2d2d2;
  text-align:center;
}

.total-block .value {
  font-size: 18px;
  font-weight: 700;
}

.action-col,
.action-row,
.action-cell, .v-btn:not(.v-btn--round).v-size--default {
  height: 69px!important;
  min-height: 100%!important;
}

.action-btn {
  height: 100%;
  border-radius: 0;
  font-weight: 700;
}

.result-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.result-price {
  font-weight: 700;
  margin-right: 16px;
}

.result-price-wrap {
  margin-right: 16px;
  text-align: right;
}

@media (max-width: 960px) {
  .homedepot-main {
    min-height: auto;
  }

  .bottom-bar {
    flex-direction: column;
    gap: 12px;
  }
}
</style>
